import React from 'react'
import $ from 'jquery';
import  '../Styles/BottomCarousel.css'
import sponser1 from '../assets/images/zee-tv.jpg'
import sponser2 from '../assets/images/wipro.jpg'
import sponser3 from '../assets/images/volkswagen.jpg'
import sponser4 from '../assets/images/tata-motors.jpg'
import sponser5 from '../assets/images/intel.jpg'
import sponser6 from '../assets/images/insight-automation.jpg'
import sponser7 from '../assets/images/mu-sigma.jpg'
import sponser8 from '../assets/images/minacs.jpg'
import sponser9 from '../assets/images/accel.jpg'

const BottomCarousel = () => {
   $(document).ready(function(){
      $('.owl-carousel').owlCarousel({
        items: 10, // Number of items visible at once
        loop: true, // Loop the carousel
        margin: 10, // Space between items
        autoplay: true, // Autoplay the carousel
        autoplayTimeout: 1000, // Autoplay interval in milliseconds
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1024: {
            items: 4
          }
        }
      });
    });
  return (
    <section className='bottom-callAction'>
    <div className="callAction">
       <div className="container">
          <h2 ><span>Call to</span>  Action</h2>
          <p>A dedicated service awaits your queries.<br/> 
             Get in touch with us.  
          </p>
          <a data-toggle="modal" data-target="#myModal"  href="javascript">Call Us Now</a>
       </div>
    </div>
    <div className='scroll-card-bg'>
        <div className="container backg-color">
         <div className="owl-carousel">
            <div className="item"><img src={sponser1} alt="Image 1" /></div>
            <div className="item"><img src={sponser2} alt="Image 2" /></div>
            <div className="item"><img src={sponser3} alt="Image 3" /></div>
            <div className="item"><img src={sponser4} alt="Image 3" /></div>
            <div className="item"><img src={sponser5} alt="Image 3" /></div>
            <div className="item"><img src={sponser6} alt="Image 3" /></div>
            <div className="item"><img src={sponser7} alt="Image 3" /></div>
            <div className="item"><img src={sponser8} alt="Image 3" /></div>
            <div className="item"><img src={sponser9} alt="Image 3" /></div>
         </div>
      </div>
        </div>
        <div>
          
        </div>
   </section>
  );
}

export default BottomCarousel






